import * as z from 'zod'

import { updateDateOnPrepareHook, updateDateOnSubmitHook } from '@flows/configs/shared/hooks'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return schemaUtils.bornOnErrorMap(issue) ?? { message: ctx.defaultError }
}

const dog_owner_age = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: BaseSchema_ContentsV1GetsafeDe.shape.born_on,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_owner_age.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    nextStep: 'dog_previously_owned',
    subFlow: params.subFlow,
    onPrepare: updateDateOnSubmitHook(params.helperFunctions.getParamPath),
    onSubmit: updateDateOnPrepareHook(params.helperFunctions.getParamPath),
  }) as const satisfies AnyStepConfiguration

export default dog_owner_age
